import { pickBy, identity } from 'lodash'
import qs from 'qs'
import { libraryFilters, pdl } from '@edulastic/constants'

const { SMART_FILTERS } = libraryFilters
const {
  pearToAIGradeMap,
  pearToAISubjectMap,
  PDL_SUBJECTS_MAP,
  pdlToPearGradeMap,
} = pdl

/** Read PDL bulk handoff from `location.state` (inbound navigation only; not persisted). */
export function parsePdlBulkHandoffFromLocation(location = {}) {
  const st = location.state || {}
  const bulkConversionId = st.bulkConversionId
  const fromBulkConvert = Boolean(st.fromBulkConvert)
  return { bulkConversionId, fromBulkConvert }
}

/** Map flat Pear `conversion` fields → My Tests `grades` / `subject` filter values. */
function defaultFiltersFromConversion(c) {
  const grades = []
  let pearGradeKey = null
  if (c.grade_code != null && String(c.grade_code).trim() !== '') {
    pearGradeKey = String(c.grade_code).trim()
  } else if (
    c.grade_level_id != null &&
    String(c.grade_level_id).trim() !== ''
  ) {
    const n = parseInt(String(c.grade_level_id).trim(), 10)
    if (!Number.isNaN(n)) pearGradeKey = pdlToPearGradeMap(n)
  }
  if (pearGradeKey) {
    const pa = pearToAIGradeMap(pearGradeKey)
    if (pa) grades.push(pa)
  }

  const subject = []
  let pdlEntry = null
  if (c.subject_code != null && String(c.subject_code).trim() !== '') {
    const code = String(c.subject_code).trim().toUpperCase()
    pdlEntry = Object.values(PDL_SUBJECTS_MAP).find((s) => s.code === code)
  } else if (c.subject_id != null && String(c.subject_id).trim() !== '') {
    const sid = String(c.subject_id).trim()
    pdlEntry = Object.values(PDL_SUBJECTS_MAP).find((s) => String(s.id) === sid)
  }
  if (pdlEntry) {
    const pa = pearToAISubjectMap(pdlEntry.description)
    if (pa) subject.push(pa)
  }

  return { grades, subject }
}

/**
 * Route to My Tests after PDL bulk upload. Pear sends a flat `conversion` object.
 * `conversion_id` and handoff flags are passed once on `location.state`; TestList copies
 * them into React state and clears router state. Grades/subjects go on the query string.
 */
export function buildMyContentRouteAfterPdlUpload(conversion) {
  const { grades, subject } =
    conversion && typeof conversion === 'object'
      ? defaultFiltersFromConversion(conversion)
      : { grades: [], subject: [] }

  const query = pickBy(
    {
      filter: SMART_FILTERS.AUTHORED_BY_ME,
      page: 1,
      limit: 20,
      ...(grades.length ? { grades } : {}),
      ...(subject.length ? { subject } : {}),
    },
    identity
  )
  const search = `?${qs.stringify(query)}`
  return {
    pathname: '/author/tests',
    search,
    state: {
      fromBulkConvert: true,
      bulkConversionId: conversion?.conversion_id,
    },
  }
}
